import {ITheme} from 'contexts/ThemeContext';
import {Platform, StyleSheet, useWindowDimensions} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  maxSize,
  minSize,
} from 'rn-responsive-styles';

export default (props: ITheme) => {
  const width = useWindowDimensions().width;

  return CreateResponsiveStyle(
    {
      container: {},
      shareContainer: {
        flex: 1,
        margin: 15,
        marginTop: 0,
      },
      shareContainerTopSpacer: {
        marginTop: 15,
      },
      listContainerFixedHeight: {
        height: 102,
        flexDirection: 'row',
      },
      listContainerHideHeight: {
        height: 0,
        flexDirection: 'row',
      },
      listContainer: {
        flex: 1,
        flexDirection: 'row',
      },
      list: {
        flex: 1,
        paddingLeft: 15,
      },
      pageContainer: {
        width,
        flexDirection: 'row',
        flexWrap: 'wrap',
      },
      rightArrowContainer: {
        marginRight: 15,
        alignSelf: 'center',
      },
      leftArrowContainer: {
        marginLeft: 15,
        alignSelf: 'center',
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {
        container: {
          marginLeft: 30,
          marginRight: 30,
          backgroundColor: props.colors.white,
          borderRadius: 20,
          marginBottom: 12,
          flex: 1,
          ...(Platform.OS === 'web'
            ? {
                boxShadow: `0px 0px 10px ${props.colors.shadowGrey}`,
              }
            : {}),
        },
        listContainer: {
          // alignItems: 'center',
        },
        list: {
          paddingLeft: 0,
        },
        pageContainer: {
          paddingTop: 15,
          paddingLeft: 15,
          justifyContent: 'center',
        },
      },
      [maxSize(DEVICE_SIZES.EXTRA_SMALL_DEVICE)]: {
        container: {
          flex: 1,
        },
      },
    },
  )();
};
